module.exports = __webpack_public_path__ + "static/media/dali.71f465ce.png";